import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { Dashboard } from './pages/Dashboard';
import { CalendarPage } from './pages/CalendarPage';
import { Users } from './pages/Users';
import { Roles } from './pages/Roles';
import { Settings } from './pages/Settings';
import { AuditLog } from './pages/AuditLog';
import { TvPabellon, TvRecuperacion } from './pages/TvDisplay';
import { TvPanel } from './pages/TvPanel';
import { DoctorAgenda } from './pages/DoctorAgenda';
import Management from './pages/Management';
import PublicCalendar from './pages/PublicCalendar';
import { Toaster } from './components/ui/sonner';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/publico/calendario/:token" element={<PublicCalendar />} />
          
          {/* TV Display - Public, no login required */}
          <Route path="/tv/pabellon" element={<TvPabellon />} />
          <Route path="/tv/recuperacion" element={<TvRecuperacion />} />
          <Route path="/agenda/:doctorId" element={<DoctorAgenda />} />
          
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <Layout>
                  <CalendarPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/users"
            element={
              <ProtectedRoute anyPermission={['user.manage']}>
                <Layout>
                  <Users />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/roles"
            element={
              <ProtectedRoute anyPermission={['role.manage']}>
                <Layout>
                  <Roles />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/audit"
            element={
              <ProtectedRoute anyPermission={['audit.view']}>
                <Layout>
                  <AuditLog />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/settings"
            element={
              <ProtectedRoute anyPermission={['config.manage', 'state.manage', 'reminder.manage', 'api_keys.manage', 'payment_log.sync']}>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/tv-panel"
            element={
              <ProtectedRoute anyPermission={['tv.manage']}>
                <Layout>
                  <TvPanel />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/management"
            element={
              <ProtectedRoute anyPermission={['management.view']}>
                <Layout>
                  <Management />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
